import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import firebase from 'firebase/app';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  $authenticated: Observable<boolean>;
  user: firebase.User;
  errorMessage: string;
  constructor(
    public fireAuth: AngularFireAuth,
    public router: Router
  ) {
    this.$authenticated = this.fireAuth.authState.pipe(map((user) => !!user));
  }
  signIn(provider: firebase.auth.AuthProvider): Promise<any> {
    return this.fireAuth
      .signInWithPopup(provider)
      .then((result) => {
        /** @type {firebase.auth.OAuthCredential} */
        this.user = result.user;
      })
      .catch((error) => {
        this.errorMessage = error.message;
      });
  }
  signInWithGoogle(): Promise<any> {
    return this.signIn(new firebase.auth.GoogleAuthProvider());
  }
  signInWithGithub(): Promise<any> {
    return this.signIn(new firebase.auth.GithubAuthProvider());
  }

  signOut() {
    this.fireAuth
      .signOut()
      .then((_) => this.router.navigate(['/login']))
      .catch((error) => {
        console.log('signout error', error);
      });
  }
}
